import { Switch, SwitchProps, withStyles, Theme } from '@material-ui/core';
import { ColoredCommonProps } from './common';

type ColoredSwitch = { (props: SwitchProps & ColoredCommonProps): JSX.Element };

export const ColoredSwitch = withStyles<'checked', {}, ColoredCommonProps>((theme: Theme) => ({
  checked: ({ colored, coloredHover = colored }) =>
    colored && {
      color: colored,
      // backgroundColor: coloredHover,
      '&$checked': {
        color: colored,
      },
    },
  // checked: {},
  track: ({ colored, coloredHover = colored }) =>
    colored && {
      '&$track + &$checked': {
        backgroundColor: coloredHover,
      },
    },
}))(({ colored, coloredHover, ...props }: any) => <Switch {...props} />) as ColoredSwitch;
